import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { sensorGraph } from "../../../../actions";
import { Button } from "react-bootstrap";
import AnalysePopup from "./AnalysePopup";
import PropTypes from "prop-types";
import { MdBarChart } from "react-icons/md";
import { UTCTimeStampToLocal, getKeyByValue, getTimeStampFromDateRange } from "../../../../helpers";
import {
  allSensorParameters,
  allSensors,
  getSensor,
  getSensorParameters,
} from "../../../../selector/common";
import { commonConstants } from "../../../../constants";

const Analyse = ({ allSensors, allSensorParameters, bulkList, loading, bulkListingAction }) => {
  const [analysePopup, setAnalysePopup] = useState(false);
  const [graphData, setGraphData] = useState([]);

  const getAnalyse = (values) => {
    //console.log("========values", values);
    /*  const values = {
      daterange: { from: 1717266600, to: 1717352999 },
      grain: 1800,
      sensorParameters: [
        { sensor_id: "78", parameter_id: "2" },
        { sensor_id: "81", parameter_id: "7" },
      ],
      sensor_id: "78",
      parameter_id: "2",
    }; */
    bulkListingAction(values);
  };

  const togglePopup = () => {
    setAnalysePopup((prevAnalysePopup) => !prevAnalysePopup);
    setGraphData([]);
  };

  useEffect(() => {
    const result =
      bulkList &&
      bulkList.map((item) => {
        const sensorParameter = getSensorParameters(allSensorParameters, item.parameter_id);
        const graph_type = getKeyByValue(
          commonConstants.chartType,
          parseInt(sensorParameter.graph_type, 10)
        ).toLocaleLowerCase();
        const sensor = getSensor(allSensors, item.sensor_id);

        return {
          name: sensor?.title,
          type: graph_type,
          unit: sensorParameter?.unit,
          data: item.list.map((row) => [UTCTimeStampToLocal(row.ts), row.pvl]),
        };
      });

    //console.log("======result", result);
    setGraphData(result);
  }, [bulkList, allSensorParameters, allSensors]);

  return (
    <>
      <div className="analyse-wrapper">
        <Button onClick={togglePopup}>
          <MdBarChart className="ic_small" /> Analyse
        </Button>

        <AnalysePopup
          openModal={analysePopup}
          toggleModal={togglePopup}
          submitForm={getAnalyse}
          initialValues={{
            daterange: getTimeStampFromDateRange("Today"),
          }}
          graphData={graphData}
          loading={loading}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  const { bulkList, loading } = state.client.sensorGraph;
  return {
    bulkList,
    loading,
    allSensors: allSensors(state),
    allSensorParameters: allSensorParameters(state),
  };
};

const mapDispatchToProps = {
  bulkListingAction: sensorGraph.bulkListing,
};

export default connect(mapStateToProps, mapDispatchToProps)(Analyse);

// PropTypes validation
Analyse.propTypes = {
  allSensors: PropTypes.array,
  allSensorParameters: PropTypes.array,
  bulkListingAction: PropTypes.func.isRequired,
  bulkList: PropTypes.array,
  loading: PropTypes.bool,
};
